<div class="ion-padding-bottom marb5">
  <h6
    class="ion-no-margin ion-padding-horizontal title-text-color fs-4 font600"
  >
    {{ logoCarouselInfo?.display_name }}
  </h6>
  <span
    *ngIf="logoCarouselInfo?.description"
    class="padlr8 subtitle-text-color fs-1 font400"
    >{{ logoCarouselInfo?.description }}
  </span>
  <div class="scrollx no-scroll ion-padding-horizontal">
    <div
      class="scroll-item padt10"
      *ngFor="
        let item of logoCarouselInfo?.products ||
          logoCarouselInfo?.retailers ||
          logoCarouselInfo?.services
      "
    >
      <ion-card
        (click)="navigate(item)"
        class="ion-no-margin marr10 border-r10"
      >
        <ion-img
          *ngIf="item?.logo"
          [src]="item?.logo || 'https://picsum.photos/id/96/96'"
          class="logo"
        ></ion-img>
        <div class="text-overlay">
          <ion-card-subtitle
            class="line-2-clip fs-1 font400 black-text-color"
            >{{
            item?.offerMap?.[0]?.value || item?.title || item?.storeName
            }}</ion-card-subtitle
          >
        </div>
      </ion-card>
    </div>
  </div>
</div>
